import type { StartDeck } from "../stageEditor/startDeck.js";
import type { StoredRewards } from "../stageEditor/storedRewards.js";
import type { MapEdit } from "../stageEditor/mapEdit.js";
import type { StoredStage } from "./stageRecord.js";

export type EditorSnap = {
  map: MapEdit;
  name: string;
  difficulty: string;
  flavor: string;
  rewards: StoredRewards;
  startDeck: StartDeck;
};

export function applyEditorSnap(
  record: StoredStage,
  snap: EditorSnap,
  status: StoredStage["status"],
  now: number,
): StoredStage {
  return {
    ...record,
    status,
    name: snap.name || record.name,
    difficulty: snap.difficulty || record.difficulty,
    flavor: snap.flavor,
    map: snap.map,
    rewards: snap.rewards,
    startDeck: snap.startDeck,
    updatedAt: now,
  };
}
